import React, { useCallback, useRef, useEffect } from 'react';
import { useIsTouchDevice } from '../hooks';

const ZoomImg = ({ src, height = '100%', alt, onClick = () => {} }) => {
  const imgRef = useRef(null);
  const isTouchDevice = useIsTouchDevice();

  const zoomHandler = useCallback(
    (e) => {
      if (!isTouchDevice) {
        const offsetX = e.nativeEvent.offsetX ?? e.nativeEvent.touches[0].pageX;
        const offsetY = e.nativeEvent.offsetY ?? e.nativeEvent.touches[0].pageY;
        const x = (offsetX / imgRef.current.offsetWidth) * 100;
        const y = (offsetY / imgRef.current.offsetHeight) * 100;
        imgRef.current.style.backgroundPosition = x + '% ' + y + '%';
      }
    },
    [imgRef, isTouchDevice]
  );

  return (
    <div
      className='tw:relative tw:flex tw:justify-center tw:overflow-hidden tw:cursor-zoom-in tw:bg-position-50-50 tw:hover:bg-no-repeat tw:hover:[background-image:var(--bg-image)] tw:max-w-[600px] tw:max-h-[600px]'
      onClick={onClick}
      onMouseMove={zoomHandler}
      style={{ '--bg-image': `url(${src})` }}
      ref={imgRef}>
      <img
        src={src}
        style={{ height }}
        alt={alt}
        className='tw:transition-opacity tw:duration-500 tw:block tw:w-auto tw:bg-white tw:hover:opacity-0'
      />
    </div>
  );
};

export default ZoomImg;
